import { render, staticRenderFns } from "./supportLayout.vue?vue&type=template&id=2d0a6646&"
import script from "./supportLayout.vue?vue&type=script&lang=ts&"
export * from "./supportLayout.vue?vue&type=script&lang=ts&"
import style0 from "./supportLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports